/* ==========================================================================
   AMALGAM — "View all results" follows the top query suggestion
   --------------------------------------------------------------------------
   THE PROBLEM: predictive search prefix-matches, full search does not. Typing
   "bent" shows nine Bentley products in the dropdown, but submitting the raw
   term lands on a full search that matches ZERO products — verified 2026-08-28
   ("bent" -> 0 products, "bentley" -> 9). The customer sees results, clicks
   through, and gets nothing.

   THE FIX: the dropdown already renders Shopify's query suggestions as pills
   ("BENTLEY", "BENTLEY CONTINENTAL", ...), and those DO return results because
   they are complete terms. So the button follows the first pill instead of
   submitting the partial text.

   Falls back to a normal form submit when there is no suggestion, so a fully
   typed query behaves exactly as before. Delegated from the document, so it
   covers the header modal and the search page's inline field, and survives the
   dropdown being re-injected over AJAX.
   ========================================================================== */

(function () {
  'use strict';

  var BUTTON = '.predictive-search__search-button';
  var PILL = 'a.predictive-search-results__pill';

  /* Keep the results page products-only so Shopify's count matches what the
     grid can actually draw — page/article hits are counted but never rendered. */
  function productsOnly(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (!url.searchParams.has('type')) url.searchParams.set('type', 'product');
      return url.pathname + url.search;
    } catch (e) {
      return href;
    }
  }

  /* The pill nearest the clicked button — scoped to its own search component so
     the header modal and the page field can coexist without stealing from each
     other. */
  function topSuggestion(button) {
    var scope = button.closest('predictive-search-component') || document;
    return scope.querySelector(PILL);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest(BUTTON) : null;
      if (!button) return;

      var pill = topSuggestion(button);
      if (!pill) return; // nothing suggested — let the form submit as normal

      var href = pill.getAttribute('href');
      if (!href) return;

      event.preventDefault();
      window.location.assign(productsOnly(href));
    },
    true
  );
})();
